export default __webpack_public_path__ + "static/media/main-img2.fce29ad3.jpeg";